import { AutoComplete } from "antd";

const testUnits = [
    { value: 'mmol/L', label: 'mmol/L' },
    { value: 'μmol/L', label: 'μmol/L' },
    { value: 'IU/L', label: 'IU/L' },
    { value: 'ng/mL', label: 'ng/mL' },
    { value: 'pg/mL', label: 'pg/mL' },
    { value: 'cells/μL', label: 'cells/μL' },
    { value: 'mg/dL', label: 'mg/dL' },
    { value: 'g/dL', label: 'g/dL' },
    { value: 'mEq/L', label: 'mEq/L' },
    { value: 'U/L', label: 'U/L' },
    { value: '%', label: '%' },
    { value: 'fL', label: 'fL' },
    { value: 'μg/dL', label: 'μg/dL' },
    { value: 'μIU/mL', label: 'μIU/mL' },
    { value: 'mL/min', label: 'mL/min' },
    { value: 'mg', label: 'mg' },
    { value: 'g', label: 'g' },
];

const TestUnitInput = ( {value, onChange, className} ) => {
    return (
        <AutoComplete
            className={`w-full ${className}`}
            options={testUnits}
            placeholder="Select unit..."
            value={value}
            onSelect={(value) => {
                // console.log('Selected:', value)
                onChange(value);
            }}
            onSearch={(searchText) => {
                // console.log('Searching for:', searchText);
                onChange(searchText);
            }}
        />
    );
}

export default TestUnitInput;